import React from 'react';
import { useState, useEffect } from 'react';
import '../viewFiles/common.scss';
import axios from 'axios';
import urls from '../../utils/url';
import { limitStr, charLimit, isJson, TooltipComponent, getReadableDateOnly, getReadableTimeOnly } from '../../utils/converter';
import Loading from '../common/loading';
import Reload from '../common/Reload';
import Cookie from 'js-cookie';

const NavamPatientInfoComponent = (props) => {

    const { patientID } = props;
  const cookie = Cookie.get('access_token')
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState(false);
  const [ patientBasicInfo, setPatientBasicInfo ] = useState({});

  useEffect(() => {
    setLoading(true)
    axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=basic_detail,user_details&`,
        {
          headers: {
          'Request-ID': 'allow|me', 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookie}`
        }
        }).then((res) => {
          if(res.data){
            const json_data = isJson(res.data)
            setPatientBasicInfo(json_data.response[0]);
            setLoading(false) 
          }
        }).catch((err) => {
          console.log("Error in Fetching Data",err);
          setError(true)
          setPatientBasicInfo({})
          setLoading(false)
        }
      ) 
  }, [patientID])

  const DoctorNameDisplay = ({ userDetails, doctorId }) => {
    const doctorName = userDetails?.[doctorId]?.first_name;
  
    if (!doctorName) {
      return <p className='text-2'>--</p>;
    }
  
    return doctorName.length > 18 ? (
      <TooltipComponent
        title={doctorName}
        content={limitStr(doctorName, 18, 'text-2')}
      />
    ) : (
      <p className='text-2'>{doctorName}</p>
    );
  };

  return (
     <>
      {
        loading ?
          <div className='loading-div'>
            <Loading/>
          </div> 
        : error ?
          <div className='reload-div'>
            <Reload/>
          </div>
        :
    
        <div className = 'info-section'>

          {/* Patient Basic Detail */}
          <>
            <div className = 'info-header'>
              <p className = 'heading'> Patient Information</p>
            </div>

            <div className = 'info-container'>
              
              <div>
                <p className='text1'>Patient's Name</p>
                {patientBasicInfo.basic_detail?.name && patientBasicInfo.basic_detail?.name.length > charLimit ? 
                  <TooltipComponent title={`${patientBasicInfo.basic_detail?.name}`} content={limitStr(patientBasicInfo.basic_detail?.name, charLimit)} />
                  : 
                  <p className='text2'>{patientBasicInfo.basic_detail?.name ? patientBasicInfo.basic_detail.name : '- -'}</p>
                }
              </div>

              <div>
                  <p className = 'text1'> DOB </p>
                  <p className = 'text2'> {patientBasicInfo.basic_detail?.dob ? patientBasicInfo.basic_detail?.dob : "- -" } </p>
              </div>

              <div>
                  <p className = 'text1'> Doctor Assigned </p>
                  <DoctorNameDisplay
                    userDetails={patientBasicInfo.user_details}
                    doctorId={patientBasicInfo.basic_detail?.registration_doctor_id}
                  />
              </div>


              <div>
                  <p className = 'text1'> Contact Number</p>
                  <p className = 'text2'> {patientBasicInfo.basic_detail?.phone ? patientBasicInfo.basic_detail?.phone : "- -"} </p>
              </div>

              <div>
                  <p className = 'text1'> Admission Date </p>
                  <p className = 'text2'> {getReadableDateOnly(patientBasicInfo.basic_detail?.register_time)} </p>
              </div>
                  
              <div>
                  <p className = 'text1'> Admission Time </p>
                  <p className = 'text2'> {getReadableTimeOnly(patientBasicInfo.basic_detail?.register_time)} </p>
              </div>

              <div>
                  <p className = 'text1'> Gender </p>
                  <p className = 'text2'> {patientBasicInfo.basic_detail?.gender ? ( patientBasicInfo.basic_detail.gender === 'FEMALE' ? 'Female' : patientBasicInfo.basic_detail.gender === 'MALE' ? 'Male' : patientBasicInfo.basic_detail.gender ) : "- -"} </p>
              </div>

              

            </div>
          </>
          

        </div> 
  
      }
    </> 
  )
}

export default NavamPatientInfoComponent


